import styled from 'styled-components'
import { mildGray, softGray, blue } from '../../styles/variables.js'


const TableWrapper = styled.div`
  padding: 5px 0;
  width: min-content;
  min-width: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
`

const TableContainer = styled.div`
  flex: 1 1;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  z-index: 0;

  & > div {
    max-height: 100%;
    min-height: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
`

const Table = styled.table`
  width: 100%;
`
const TableHead = styled.thead`
  color: ${mildGray};
  font-weight: bold;
  font-size: 12px;
`

const TableBody = styled.tbody`
`

const TableRow = styled.tr`
  &:last-child {
    td {
      padding-bottom: 100px;
    }
  }
`

const Group = styled.td`
  font-size: 18px;
  padding-top: 10px;
  padding-left: 30px;
`

const HeaderCell = styled.th`
  vertical-align: middle;
  padding-bottom: 4px;
  position: sticky;
  top: 0;
  z-index: 10;
  background: ${softGray};
  text-align: start;
  padding-left: 13px;
  &.sorted {
    color: ${blue};
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
`

const TableCell = styled.td`
  vertical-align: middle;
  padding-bottom: 8px;
`

const TableCellContent = styled.div`
  padding: 12px;
  background: white;
  margin: 0 1px;

  ${({ noPadding }) => noPadding ? 'padding: 0;' : ''}
  ${({ center }) => center ? `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  ` : ''}
`

const Sorter = styled.span`
  margin-left: 8px;
  position: relative;
`

const SortIcon = styled.span`
  position: absolute;
  top: ${({ direction }) => direction === 'circular' ? '0px' : direction === 'asc' ? '2px' : '-2px'};
`

const Pagination = styled.div`

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ul {
    display: inline-block;
    padding-left: 15px;
    padding-right: 15px;
  }

  li {
    display: inline-block;
    cursor: pointer;
    outline: none;
    margin: 0 6px;

    & > a {
      outline: none;
      color: black;
      border-radius: 50%;
      height: 32px;
      padding: 7px 0;
      min-width: 32px;
      box-sizing: border-box;
      text-align: center;
      display: block;
    }

    &:hover a {
      opacity: 0.7;
      background: ${blue};
      color: white;
    }

    &.selected a {
      background: ${blue};
      color: white;
      cursor: default;
      opacity: 1;
      &:hover {
        opacity: 1;
      }
    }

    &.previous, &.next {
      & > a {
        background: none;
        color: black;
        &:hover {
          background: ${blue};
          color: white;
        }
      }
    }

    &.disabled a {
      opacity: 0.3;
      cursor: default;
      &:hover {
        background: none;
        color: black;
      }
    }
  }
`

export default {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableCellContent,
  TableContainer,
  HeaderCell,
  TableWrapper,
  Group,
  Sorter,
  SortIcon,
  Pagination,
}
